import { Locale } from './locale';

export const categoryPath = (categoryKey: string) => `/${categoryKey}`;
export const categoriesPath = () => '/categories';
export const categoryLaunchPath = (categoryKey: string) => `/launch/${categoryKey}`;
export const categoryContestsPath = (categoryKey: string) => `/${categoryKey}/contests`;
export const projectsPath = () => '/projects';
export const profilePath = (userId: string) => `/profiles/${userId}`;
export const avatarPath = (userId: string, size = 64) => `/avatars/users/${userId}/${size}`;
export const invitePath = (userId: string) => `/profiles/${userId}/invites`;
export const reviewsPath = (userId: string) => `/profiles/${userId}/about#reviews`;
export const designPath = (designerId: string, designId: number) =>
    `/profiles/${designerId}/designs/${designId}`;
export const designerSearchPath = (categoryKey?: string) =>
    categoryKey ? `/designers/search?categories=${categoryKey}` : `/designers/search`;
export const testimonialPath = (categoryKey?: string) =>
    categoryKey ? `/testimonials/${categoryKey}` : `/testimonials`;
export const inviteDesignerToWorkPath = (userId: string) => `/profiles/${userId}/invites`;
export const squareOnlineStoreBrief = () => '/briefs/square-online-store/create';
export const squareSpaceBrief = () => '/briefs/squarespace/create';
export const genericWebBuilderBrief = () => '/briefs/web-builder/create';
export const webBuilderLanding = () => '/website-builders';
export const webOnboarderGetStartedPath = () => '/web/get-started';

export const blogImageFileTypesPath = (locale: string) => {
    const language = Locale.getLanguage(locale);
    if (language === 'de') {
        return '/blog/design-tipps/bilddateiformate/';
    }
    if (language === 'fr') {
        return '/blog/conseils-design/formats-fichiers-images/';
    }
    return '/blog/tips/image-file-types/';
};

export const blogTypesOfLogosPath = () => '/blog/tips/types-of-logos/';
export const blogLogoColorMeaningsPath = () => '/blog/tips/logo-color-meanings/';
export const blogLogoShapesPath = () => '/blog/tips/logo-shapes/';
export const blogLogoBranding = () => '/blog/logo-branding/';
export const blogHowToCreateALogoPath = () => '/blog/logo-branding/how-to-create-logo/';
export const blogBestLogoMakersPath = () => '/blog/logo-branding/best-logo-makers/';
export const blogLogoFontsPath = () => '/blog/logo-branding/logo-fonts/';
export const blogLogoDesignCostPath = () => '/blog/logo-branding/logo-design-cost/';
export const blogBadLogoDesign = () => '/blog/logo-branding/bad-logo-design/';
export const blogSupplementVitaminBranding = () =>
    '/blog/logo-branding/supplement-vitamin-branding/';
export const blogMerchandiseBranding = () => '/blog/logo-branding/merchandise-branding/';
export const blogLogoDesignAppsPath = () => '/blog/resources/logo-design-apps/';
export const blogBestLogoDesignersPath = () => '/blog/designers/best-logo-designers/';
export const pricingPath = () => '/pricing';
export const categoryPricingPath = (categoryKey: string) => `/pricing/${categoryKey}`;
export const loginPath = (target?: string) =>
    target ? `/login?target=${encodeURIComponent(target)}` : `/login`;
export const designConsultationPath = () => `/design-consultation`;
export const discoverPath = () => `/discover`;

export const support = {
    designerLevelUrl: function (locale: string) {
        return this.url(locale, '115002951643-Understanding-designer-levels');
    },
    moneyBackUrl: function (locale: string) {
        return this.url(locale, '204108729-100-Money-back-guarantee-For-real');
    },
    guaranteedContestUrl: function (locale: string) {
        return this.url(locale, '204761955-What-is-a-guaranteed-design-contest');
    },
    privateContestUrl: function (locale: string) {
        return this.url(locale, '204761515-Can-I-hide-my-contest-from-search-engines');
    },
    newSupportRequest: function (locale: string) {
        return `http://support.99designs.com/hc/${Locale.getLanguage(locale)}/requests/new`;
    },
    url: function (locale: string, slug: string) {
        return `http://support.99designs.com/hc/${Locale.getLanguage(locale)}/articles/${slug}`;
    },
    helpCenter: function (locale: string) {
        return `https://support.99designs.com/hc/${Locale.getLanguage(locale)}`;
    },
};
